import React, { Component } from 'react';
// import axios from "../../utils/axiosInstance";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './PopularDestinations.css';

class PopularDestinations extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mainDestination: {
        id: 'mohammadpur',
          name: 'Mohammadpur',
          location: 'Dhaka, Bangladesh',
          image: 'https://images.unsplash.com/photo-1590073844006-33379778ae09?w=600&q=80&auto=format&fit=crop'
      },
      subDestinations: [
        {
        id: 'mirpur',
        name: "Mirpur",
        location: 'Dhaka, Bangladesh',
        image: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=600&q=80&auto=format&fit=crop'
          
        },
        {
          id: 'dhanmondi',
          name: 'Dhanmondi',
          location: 'Dhaka, Bangladesh',
          image: 'https://images.unsplash.com/photo-1470246973918-29a93221c455?w=400&q=80&auto=format&fit=crop'
        },
        {
          id: 'uttara',
          name: 'Uttara',
          location: 'Dhaka, Bangladesh',
          image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&q=80&auto=format&fit=crop'
        },
        {
          id: 'bashundhara',
          name: 'Bashundhara',
          location: 'Dhaka, Bangladesh',
          image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&q=80&auto=format&fit=crop'
        }
      ]
    };
  }

  handleSearch = (address) => {
    window.location.href = `/q?t=&a=${encodeURIComponent(address)}&s=&e=&r=1&ad=2&k=0`;
  };

  render() {
    const { mainDestination, subDestinations } = this.state;

    return (
      <section className="popular-destinations-section container py-5">

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 gap-3 gap-md-0">
          <div>
            <h2 className="destinations-title mb-1">Popular Destinations</h2>
            <p className="destinations-subtitle mb-0">Explore stays in your favorite neighborhoods.</p>
          </div>
        </div>

        {/* Grid Layout Section */}
        <div className="row g-4">

          {/* Large Left Card */}
          <div className="col-lg-6">
            <div 
              onClick={() => this.handleSearch(mainDestination.name)}
              className="dest-card dest-card-large h-100 w-100"
              style={{ backgroundImage: `url(${mainDestination.image})` }}
              role="button"
              tabIndex={0}
            >
              {/* Top Right Arrow Overlay */}
              <div className="large-card-arrow">
                <i className="bi bi-arrow-right"></i>
              </div>

              <div className="dest-card-content">
                <div className="dest-location d-flex align-items-center gap-1">
                  <i className="bi bi-geo-alt"></i> {mainDestination.location}
                </div>
                <h3 className="dest-name">{mainDestination.name}</h3>
              </div>
            </div>
          </div>

          {/* Right Side 2x2 Small Cards */}
          <div className="col-lg-6">
            <div className="row g-4">
              {subDestinations.map((dest) => (
                <div 
                  className="col-sm-6" 
                  key={dest.id} 
                  onClick={() => this.handleSearch(dest.name)}
                  role="button"
                  tabIndex={0}
                >
                  <div
                    className="dest-card dest-card-small w-100"
                    style={{ backgroundImage: `url(${dest.image})` }}
                  >
                    <div className="large-card-arrow">
                      <i className="bi bi-arrow-right"></i>
                    </div>

                    <div className="dest-card-content">
                      <div className="dest-location d-flex align-items-center gap-1">
                        <i className="bi bi-geo-alt"></i> {dest.location}
                      </div>
                      <h3 className="dest-name">{dest.name}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>
    );
  }
}

export default PopularDestinations;
